import { Component, OnInit } from '@angular/core';
import { SesionService } from './shared/services/sesion.service';
import { Sesion } from './shared/models/sesion'
import { PermisoMenuDto } from './shared/models/permiso-menu-dto'
import {Router, NavigationEnd} from "@angular/router";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  constructor(private sesionService: SesionService,
  private router: Router){
    this.router.events.forEach((event)=>{
      if(event instanceof NavigationEnd) {
        this.cargarDatosSession()
      }
    })
  }

  sesion: Sesion = new Sesion();


  ngOnInit(){
    this.sesion.permisoMenuDto = new PermisoMenuDto();
    this.cargarDatosSession();
  }

  public cargarDatosSession(): void{
    if(location.hash != '#/inicio' &&  location.hash != ''){
      this.sesionService.consultarDatosSesion().subscribe(
        resultado=> this.sesion = resultado
      )
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts